//utm_source=Twitter&utm_medium=Organic&utm_campaign=2023_EV_MUS_Social

function create_link ( url ) {
    const $link = jQuery( '<a>' ).attr( 'href', url );
    jQuery( 'body' ).append( $link );
}

jQuery( function ( $ ) {

    const tracking_params = ThemeJS.Cookies.get( 'campaign_tracking' );

    if ( tracking_params ) {
        const domain_regex = new RegExp( `^${ window.location.protocol }\/\/${ window.location.hostname }` );

        function set_tracking_query_params ( el ) {
            if ( !el.href.match( domain_regex ) ) {
                var url = new URL( el.href );
                for ( var i in tracking_params ) {
                    url.searchParams.set( i , tracking_params[i] );
                }
                el.href = url.toString();
            }
        }

        $( `a[href]:not([href^='${ window.location.protocol }//${ window.location.hostname }'])` ).each( function () {
            set_tracking_query_params( this );
        });

        const observer = new MutationObserver( mutations => {
            mutations.forEach( mutation => {
                if ( mutation.type == 'childList' ) {
                    mutation.addedNodes.forEach( node => {
                        if ( node.tagName == 'A' ) {
                            set_tracking_query_params( node );
                        }
                    })
                }
            });
        });
        observer.observe( document.querySelector( 'body' ), {
            subtree: true,
            childList: true,
        });
    }

    // Navigation Events
    let headerLinks = document.querySelectorAll( ".header-main a" );
    let footerLinks = document.querySelectorAll( "footer.footer a" );
    let eventTrackers = document.querySelectorAll( "a[data-event]" );
    let registerLinksNav = document.querySelectorAll( ".header-main a.additional-btn, footer.footer a.additional-btn" );

    headerLinks.forEach( function( el ) {
        el.addEventListener( 'click', function ( event ) {
            linkClickTracker( this, 'Header - ' );
        } )
    } );
    
    footerLinks.forEach( function( el ) {
        el.addEventListener( 'click', function ( event ) {
            linkClickTracker( this, 'Footer - ' );
        } );
    } );
    
    eventTrackers.forEach( function( el ) {
        el.addEventListener( 'click', function eventLinkClickTracker( event ) {
            linkClickTracker( this, '' );
        } );
    } );
    
    registerLinksNav.forEach( function( el ) {
        el.addEventListener( 'click', function () {
            linkClickTracker( this, 'Register Header/Footer', true );
        } );
    } );
    
    function linkClickTracker( element, prepend, prependOnly = false ) {
        let data = '';

        if ( ! prependOnly ) {
            data = element.getAttribute( "data-event" );
            if ( ! data ) {
                data = element.innerText.replace( '(Opens in a new window)', '' )
            }

            let splitTest = data.split( "," );
            if ( splitTest.length > 1 ) {
                for ( let x in splitTest ) {
                    splitTest[x] = splitTest[x].trim();
                    linkClickTracker( element, `${prepend} ${splitTest[x]}`, true )
                }

                return;
            }
        }
        // console.log( prepend + data );
        if ( gtag ) {
            gtag('event', 'Click Event', {
                'event_category': 'engagement',
                'event_label': prepend + data,
                'value': 1
            });
        }
    }

});